import { handleActions } from 'redux-actions'

import * as jitsiTrackActions from '../actions/jitsiTrack'

interface JitsiTrackState {
  isVideoMuted: boolean
  isAudioMuted: boolean
  trackMuteInProcess: boolean
}

const initialState: JitsiTrackState = {
  isVideoMuted: false,
  isAudioMuted: false,
  trackMuteInProcess: false,
}

export default handleActions<JitsiTrackState, any>(
  {
    [jitsiTrackActions.setVideoMuted.toString()](state, action) {
      return { ...state, isVideoMuted: !state.isVideoMuted }
    },
    [jitsiTrackActions.setAudioMuted.toString()](state, action) {
      return { ...state, isAudioMuted: !state.isAudioMuted }
    },
  },
  initialState
)
